import { NotificationEventType } from "../../src/domain/notification/Models/NotificationEventType"

export default {
  title: "Notifications",
  empty: "You have no notifications",
  loadMore: "Load more",
  markAllRead: "Mark all as read",
  markAllReadModal: {
    title: "Mark as read",
    message: "Are you sure you want to mark all notifications as read? Once you do, the notifications will disappear.",
    confirm: "YES, CONTINUE",
  },
  eventTitle: {
    [NotificationEventType.VOTING_CREATED]: "New scheduled voting",
    [NotificationEventType.VOTING_CLOSING_SOON]: "Voting closing soon",
    [NotificationEventType.VOTING_RESULT]: "Voting finished",
    [NotificationEventType.VOTE_CONFIRMED]: "Vote confirmed",
    [NotificationEventType.SUBSCRIPTION_RENEWED]: "Subscription renewed",
    [NotificationEventType.SUBSCRIPTION_FAILED]: "Subscription failed",
    [NotificationEventType.SUBSCRIPTION_EXPIRED]: "Subscription expired",
    [NotificationEventType.SUBSCRIPTION_CANCELLED]: "Subscription cancelled",
    [NotificationEventType.KYC_APPROVED]: "Verification approved",
    [NotificationEventType.KYC_REJECTED]: "Verification rejected",
  },
  preferences: {
    subtitle: "Customize your notifications",
    inApp: {
      title: "In-app notifications",
    },
    email: {
      title: "Email notifications",
      label: "Your email",
    },
    eventLabel: {
      [NotificationEventType.VOTING_CREATED]: "New scheduled voting",
      [NotificationEventType.VOTING_CLOSING_SOON]: "Voting closing soon",
      [NotificationEventType.VOTING_RESULT]: "Voting finished (all)",
      [NotificationEventType.VOTE_CONFIRMED]: "Voting finished (voted)",
    },
  },
  eventDescription: {
    [NotificationEventType.VOTING_CREATED]: 'Check out the new voting "{{title}}"',
    [NotificationEventType.VOTING_CLOSING_SOON]: 'Voting "{{title}}" is closing soon',
    [NotificationEventType.VOTING_RESULT]: 'Check the results of the voting you participated in "{{title}}"',
    [NotificationEventType.VOTE_CONFIRMED]: 'Your vote in "{{title}}" has been confirmed',
    [NotificationEventType.SUBSCRIPTION_RENEWED]: "Your subscription has been successfully renewed",
    [NotificationEventType.SUBSCRIPTION_FAILED]: "Your subscription payment has failed",
    [NotificationEventType.SUBSCRIPTION_EXPIRED]: "Your subscription has expired",
    [NotificationEventType.SUBSCRIPTION_CANCELLED]: "Your subscription has been cancelled",
    [NotificationEventType.KYC_APPROVED]: "Your identity verification has been approved",
    [NotificationEventType.KYC_REJECTED]: "Your identity verification has been rejected",
  },
}
